<div
  class="border-weak bg-surface flex h-full w-full flex-col gap-4 overflow-y-auto rounded-sm border p-2">
  <app-form-builder
    [schema]="schema()"
    [form]="form"
    [actualValues]="actualValues()"
    [entityType]="entityType()"
    [rowId]="rowId()"
    [formMode]="formMode()" />
</div>
